import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import Header from './series-lead-elements/header';
import WhatIsInside from './series-lead-elements/what-is-inside';
import Companies from './series-lead-elements/companies';
import Form from './series-lead-elements/form';
import Footer from './series-lead-elements/footer';
import theme from '../../../assets/stylesheets/_settings.global.scss';

const Div = styled.div`
  display: flex;
  flex-direction: column;
`;

export default function Root(props) {
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
  const themeState = {
    ...props,
    ...theme,
    isPortrait,
  };

  const header = {
    title: 'How to build a bullet proof income portfolio',
    buttonText: 'download my ebook',
    desc: 'This ebook will educate you about the different income generating '
      + 'asset classes, provide expert views on the state of play in each asset '
      + 'class, and demonstrate how they can be combined to create an income '
      + 'strategy.',
  };

  const inside = {
    title: 'Learn to combine asset classes to generate income',
    desc: 'Record low interest rates mean the returns from many income '
      + 'generating assets are too skinny to live off. So, to provide a '
      + 'roadmap, in this special report Livewire provide an overview of each '
      + 'of the asset classes listed below, as well as some of the pros and '
      + 'cons of each.',
    bullets: [
      'Equities (Australia)',
      'Equities (International)',
      'Australian Government Bonds (AGBS)',
      'Corporate Bonds',
      'Unlisted Real Assets',
      'Residential Mortgage Backed Securities (RMBS)',
      'Other Debt Assets',
      'Hybrids',
      'Alternatives',
    ],
  };

  return (
    <ThemeProvider theme={themeState}>
      <Div>
        <Header header={header} />
        <WhatIsInside inside={inside} />
        <Companies ebookName={header.title} />
        <Form ebookName="income series" />
        <Footer />
      </Div>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
Root.propTypes = {
  logo: PropTypes.string.isRequired,
  cover: PropTypes.string.isRequired,
  ebook: PropTypes.arrayOf(PropTypes.string).isRequired,
  partners: PropTypes.arrayOf(PropTypes.string).isRequired,
};
/* eslint-enable react/no-unused-prop-types */
